// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__he0JB","errorLogs":"EditorFooter_errorLogs__3hkWu"};